import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  Stack,
  CircularProgress,
  Alert,
  useTheme,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { getMoveService, updateMoveService } from "../redux/action/move-service";


interface ChangePickupModalProps {
  open: boolean;
  onClose: () => void;
  canonicalId: string;
  selectedMoveServiceData:any
}

const ChangePickupModal: React.FC<ChangePickupModalProps> = ({
  open,
  onClose,
  canonicalId,
  selectedMoveServiceData
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const dwellingTypes = selectedMoveServiceData?.dwelling_type
  const [dwellingType, setDwellingType] = useState<"home" | "apartment" | "storage" | "">(dwellingTypes);

  const handleSubmit = async () => {
    if (!dwellingType) {
      setError("Please select a pickup type");
      return;
    }

    setError(null);
    setIsLoading(true);

    try {
      const updateData = {
        canonical_id: canonicalId,
        dwelling_type: dwellingType,
      };
      const res = await dispatch<any>(updateMoveService(updateData));
      unwrapResult(res);
      onClose();
    } catch (err: any) {
      setError(err.message || "Failed to update pickup");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="change-pickup-modal">
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 360,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          outline: "none",
        }}
      >
        <Typography id="change-pickup-modal" variant="h6" mb={2}>
          Change Pickup Type
        </Typography>

        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 100,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Stack direction="row" spacing={2} mb={2}>
              {["home", "apartment", "storage"].map((type) => (
                <Button
                  key={type}
                  variant={dwellingType === type ? "contained" : "outlined"}
                  onClick={() => setDwellingType(type as "home" | "apartment" | "storage")}
                  sx={{ flex: 1 }}
                >
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </Button>
              ))}
            </Stack>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button variant="outlined" onClick={onClose}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSubmit}>
                Save
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default ChangePickupModal;
